module.exports = __webpack_public_path__ + "img/Лицензия-на-меддеятельность-21.02.2018-5.3ee857a9.jpg";